module.exports = __webpack_public_path__ + "static/media/logo-ide.94c6ba0b.svg";